// Signature floodlight beam — diagonal volumetric light onto pitch grass fragment.
// Negative space is the brief: only the beam is illuminated.
import React from "react";

const PITCH_IMAGE =
    "https://images.unsplash.com/photo-1597260390010-ba4dc841b04c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export const FloodlightBeam = ({
    className = "",
    showSource = true,
    intensity = 1,
    testId = "floodlight-beam",
}) => {
    return (
        <div
            data-testid={testId}
            className={`floodlight-stage relative h-full w-full ${className}`}
            style={{
                "--pitch-image": `url('${PITCH_IMAGE}')`,
            }}
        >
            {/* faint horizon hint */}
            <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-black via-black/80 to-transparent z-[5] pointer-events-none" />

            {/* the beam panel — white volumetric */}
            <div
                className="floodlight-beam"
                style={{ opacity: 0.55 * intensity }}
            />

            {/* the lit pitch fragment */}
            <div className="floodlight-beam-pitch" />

            {/* the source — small glowing pip at the top */}
            {showSource && <div className="floodlight-source" data-testid={`${testId}-source`} />}

            {/* extra grain over the entire stage to keep it filmic */}
            <div
                className="absolute inset-0 z-[6] pointer-events-none mix-blend-overlay opacity-[0.06]"
                style={{
                    backgroundImage:
                        "radial-gradient(rgba(255,255,255,0.5) 1px, transparent 1px)",
                    backgroundSize: "3px 3px",
                }}
            />

            {/* hairline horizon — chalk line suggestion */}
            <div className="absolute left-[12%] right-[12%] bottom-[18%] h-px bg-white/15 z-[7] pointer-events-none" />
            <div className="absolute left-1/2 -translate-x-1/2 bottom-[18%] w-px h-12 bg-white/10 z-[7] pointer-events-none" />
        </div>
    );
};

export default FloodlightBeam;
